// extracted by mini-css-extract-plugin
export default {"main":"EmptyCart_main__RGt5D","img":"EmptyCart_img__0180F","button":"EmptyCart_button__-moEW"};